import ApplicationV1Adapter from 'uplisting-frontend/adapters/application-v1';

export default class UnavailabilityAdapter extends ApplicationV1Adapter {}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    unavailability: UnavailabilityAdapter;
  }
}
